// User roles and their permissions
const roles = {
  ADMIN: {
    name: 'Administrator',
    permissions: ['manage_pricing', 'view_history', 'import_export', 'bulk_update', 'view_analytics']
  },
  MANAGER: {
    name: 'Manager',
    permissions: ['view_history', 'import_export', 'view_analytics'] // No 'manage_pricing' permission
  },
  VIEWER: {
    name: 'Viewer',
    permissions: ['view_pricing']
  }
};

// Get credentials from environment variables
const getCredentials = () => {
  // Hardcoded credentials for production deployment
  // These should match the values in .env file
  return {
    adminUsername: 'admin',
    adminPassword: 'NLFXB3$TPA$$3V3R2025!',
    managerUsername: 'manager', 
    managerPassword: 'NLFXBUILD2025',
    adminToken: 'NLFX_ADMIN_TOKEN_071725'
  };
};

// Get users dynamically from environment
const getUsers = () => {
  const creds = getCredentials();
  return [
    {
      id: 1,
      username: creds.adminUsername,
      password: creds.adminPassword,
      role: 'ADMIN',
      name: 'Admin User'
    },
    {
      id: 2,
      username: creds.managerUsername,
      password: creds.managerPassword,
      role: 'MANAGER',
      name: 'Manager User'
    }
  ];
};

// Current user state
let currentUser = null;

// Login function
export async function login(username, password) {
  return new Promise((resolve, reject) => {
    const users = getUsers();
    const creds = getCredentials();
    
    const user = users.find(u => u.username === username && u.password === password);
    if (user) {
      currentUser = {
        id: user.id,
        username: user.username,
        role: user.role,
        name: user.name
      };
      localStorage.setItem('currentUser', JSON.stringify(currentUser));
      
      // Set admin token if user is admin
      if (user.role === 'ADMIN') {
        localStorage.setItem('adminToken', creds.adminToken);
      }
      
      resolve(currentUser);
    } else {
      reject(new Error('Invalid username or password'));
    }
  });
};

// Logout function
export const logout = () => {
  currentUser = null;
  localStorage.removeItem('currentUser');
  localStorage.removeItem('adminToken');
};

// Check if user is logged in
export const isAuthenticated = () => {
  if (!currentUser) {
    const savedUser = localStorage.getItem('currentUser');
    if (savedUser) {
      currentUser = JSON.parse(savedUser);
    }
  }
  return !!currentUser;
};

// Get current user
export const getCurrentUser = () => {
  if (!currentUser) {
    const savedUser = localStorage.getItem('currentUser');
    if (savedUser) {
      currentUser = JSON.parse(savedUser);
    }
  }
  return currentUser;
};

// Check if user has specific permission
export const hasPermission = (permission) => {
  const user = getCurrentUser();
  if (!user) return false;
  
  const userRole = roles[user.role];
  return userRole && userRole.permissions.includes(permission);
};

// Check if user has any of the specified permissions
export const hasAnyPermission = (permissions) => {
  return permissions.some(permission => hasPermission(permission));
};

// Check if user has all of the specified permissions
export const hasAllPermissions = (permissions) => {
  return permissions.every(permission => hasPermission(permission));
};

// Get user role name
export const getUserRoleName = () => {
  const user = getCurrentUser();
  if (!user) return null;
  
  const userRole = roles[user.role];
  return userRole ? userRole.name : null;
};

// Get all available roles
export const getAvailableRoles = () => {
  return Object.entries(roles).map(([key, value]) => ({
    id: key,
    name: value.name,
    permissions: value.permissions
  }));
};

// Get all available permissions
export const getAllPermissions = () => {
  const permissions = new Set();
  Object.values(roles).forEach(role => {
    role.permissions.forEach(permission => permissions.add(permission));
  });
  return Array.from(permissions);
}; 

export function getAdminToken() {
  return localStorage.getItem('adminToken') || getCredentials().adminToken;
} 